import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

const NIGHT_BG =
  "https://customer-assets.emergentagent.com/job_vammos-coastal-vibes/artifacts/gbqrt4xc_IMG_0098.webp";

const reveal = {
  initial: { opacity: 0, y: 36 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-70px" },
  transition: { duration: 1, ease: [0.22, 1, 0.36, 1] },
};

export const Events = () => {
  const { t } = useLang();
  return (
    <section className="events" id="events" data-testid="events-section">
      <div className="events__bg">
        <img src={NIGHT_BG} alt="Sand life nights" loading="lazy" />
      </div>
      <div className="container">
        <motion.div className="events__head" {...reveal}>
          <p className="label">{t.events.label}</p>
          <h2 className="display">
            {t.events.titleA} <em>{t.events.titleB}</em>
          </h2>
          <p className="events__intro">{t.events.intro}</p>
        </motion.div>

        <div className="events__list">
          {t.events.list.map((e, i) => (
            <motion.article
              key={e.name}
              className="event-card"
              data-testid={`event-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-30px" }}
              transition={{ duration: 0.8, delay: 0.08 * i, ease: [0.22, 1, 0.36, 1] }}
            >
              <span className="event-card__num">{["I", "II", "III", "IV"][i]}</span>
              <h3 className="event-card__name">{e.name}</h3>
              <p className="event-card__when">{e.when}</p>
              <p className="event-card__desc">{e.desc}</p>
            </motion.article>
          ))}
        </div>

        <div className="events__sound">
          {t.events.sound.map((s, i) => (
            <motion.div
              key={s.name}
              className="sound-row"
              data-testid={`sound-row-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: 0.1 * i }}
            >
              <span className="sound-row__time">{s.time}</span>
              <span className="sound-row__name">{s.name}</span>
              <span className="sound-row__desc">{s.desc}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Events;
